module.exports = __webpack_public_path__ + "media/assets/experiences-f645a72d.png";